module.exports = __webpack_public_path__ + "img/Ingles IV.a8f55ca5.png";